import React from 'react';

const CertificationAwardComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">Certifications and awards</h1>
      <p className="alt-text">If you have received any official certifications or awards for your engineering skills, adding them here is a good way to validate your technical ability.</p>
      <h1 className="sub-title">Example</h1>
      <div className="panel">
        <p className="sub-title">Certifications and awards</p>
        <ul className="item-list">
          <li>2020 Google Cloud Data Engineer</li>
          <li>2020 Google Cloud Architect</li>
          <li>2020 AWS Solution Architect Associate</li>
          <li>2020 Azure Solution Architect Expert</li>
        </ul>
        <p className="alt-text">Other certifications:</p>
        <ul className="item-list">
          <li>Red Hat Certified Engineer</li>
          <li>Udacity React Nanodegree</li>
          <li>Udacity Deep Learnings Nanodegree</li>
          <li>Udacity Cloud Devops Engineer Nanodegree</li>
        </ul>
      </div>
    </div>
  );
};

export default CertificationAwardComponent;
